/**
 * Integración visual Regios + YMQ Cart Drawer
 *
 * Shopify y Regios calculan correctamente los descuentos, pero el mini cart
 * de YMQ muestra sus propios precios. Este script toma los importes finales
 * desde /cart.js y los refleja dentro del drawer sin modificar YMQ.
 */

window.ncRegiosYmqFixLoaded = true;
console.log('NC Regios + YMQ cargado');

(() => {
  const SELECTORS = {
    itemPriceBox: '.ymq-cart-app-final-price',
    ymqItemPrice:
      '[ymq-b2b-item-final-line-price][ymq-b2b-item-key]',
    checkoutTotalBox: '.ymq-cart-app-total',
    checkoutTotalOriginal: '.ymq-cart-app-total > .ymq-cart-price-span'
  };

  let updateTimer = null;
  let requestInProgress = false;

  function formatMoney(cents, currency = 'MXN') {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100);
  }

  async function getCart() {
    const root = window.Shopify?.routes?.root || '/';

    const response = await fetch(`${root}cart.js`, {
      cache: 'no-store',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`No se pudo consultar el carrito: ${response.status}`);
    }

    return response.json();
  }

  function updateItemPrices(cart) {
    const priceBoxes = document.querySelectorAll(
      SELECTORS.itemPriceBox
    );

    priceBoxes.forEach((priceBox) => {
      const ymqPriceContainer = priceBox.querySelector(
        SELECTORS.ymqItemPrice
      );

      if (!ymqPriceContainer) {
        return;
      }

      const ymqKey =
        ymqPriceContainer.getAttribute('ymq-b2b-item-key') || '';

      const cartItem = cart.items.find((item) =>
        ymqKey.endsWith(item.key)
      );

      if (!cartItem) {
        return;
      }

      /*
       * YMQ puede continuar actualizando este elemento internamente,
       * pero permanece oculto. No modificamos sus atributos.
       */
      ymqPriceContainer.style.setProperty(
        'display',
        'none',
        'important'
      );

      let customPrice = priceBox.querySelector(
        '.nc-regios-mini-cart-price'
      );

      if (!customPrice) {
        customPrice = document.createElement('span');
        customPrice.className = 'nc-regios-mini-cart-price';
        priceBox.appendChild(customPrice);
      }

      const formattedPrice = formatMoney(
        cartItem.final_line_price,
        cart.currency || 'MXN'
      );

      if (customPrice.textContent !== formattedPrice) {
        customPrice.textContent = formattedPrice;
      }
    });
  }

  function updateCheckoutTotal(cart) {
    const totalBox = document.querySelector(
      SELECTORS.checkoutTotalBox
    );

    if (!totalBox) {
      return;
    }

    const checkoutButton = totalBox.closest(
      '.ymq-cart-app-checkout-button'
    );

    if (!checkoutButton) {
      return;
    }

    const discountedTotal = cart.items.reduce(
      (total, item) => total + item.final_line_price,
      0
    );

    const formattedTotal = formatMoney(
      discountedTotal,
      cart.currency || 'MXN'
    );

    /*
    * YMQ reconstruye constantemente su precio interno.
    * En lugar de modificarlo, ocultamos todo su contenedor.
    */
    totalBox.style.setProperty(
      'display',
      'none',
      'important'
    );

    /*
    * Nuestro precio se agrega directamente dentro del botón,
    * pero fuera del elemento que YMQ reescribe.
    */
    let customTotal = checkoutButton.querySelector(
      ':scope > .nc-regios-mini-cart-total'
    );

    if (!customTotal) {
      customTotal = document.createElement('span');
      customTotal.className = 'nc-regios-mini-cart-total';
      checkoutButton.appendChild(customTotal);
    }

    const visibleTotal = ` ${formattedTotal}`;

    if (customTotal.textContent !== visibleTotal) {
      customTotal.textContent = visibleTotal;
    }
  }

  async function updateYmqDrawer() {
    if (requestInProgress) {
      return;
    }

    const drawerExists =
      document.querySelector(SELECTORS.itemPriceBox) ||
      document.querySelector(SELECTORS.checkoutTotalBox);

    if (!drawerExists) {
      return;
    }

    requestInProgress = true;

    try {
      const cart = await getCart();

      updateItemPrices(cart);
      updateCheckoutTotal(cart);
    } catch (error) {
      console.error(
        'Error en integración visual Regios + YMQ:',
        error
      );
    } finally {
      requestInProgress = false;
    }
  }

  window.ncUpdateYmqDrawer = updateYmqDrawer;

  function scheduleUpdate(delay = 150) {
    window.clearTimeout(updateTimer);

    updateTimer = window.setTimeout(() => {
      updateYmqDrawer();
    }, delay);
  }

  const observer = new MutationObserver(() => {
    scheduleUpdate();
  });

  function initialize() {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener('click', () => {
      scheduleUpdate(300);
    });

    document.addEventListener('change', () => {
      scheduleUpdate(300);
    });

    document.addEventListener('input', () => {
      scheduleUpdate(300);
    });

    scheduleUpdate(500);

    // Respaldo por si YMQ actualiza el drawer sin generar un evento detectable.
    window.setInterval(updateYmqDrawer, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();


/* =========================================================
   Checkout directo desde el mini carrito de YMQ
   ========================================================= */

document.addEventListener(
  'click',
  function (event) {
    const checkoutButton = event.target.closest(
      '.ymq-cart-app-checkout-button[name="checkout"]'
    );

    if (!checkoutButton) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    window.location.assign('/checkout');
  },
  true
);